import { isTouchScreen } from '../../utils/screenUtils';
import { HoverDelete } from '../task/manage/ManageTaskDialog.styles';
import styled, { css } from 'styled-components';

/** A section heading in Course details: sentence case and darker than the text under it (Petr, 2026-10-09). */
export const CourseSectionTitle = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: ${props => props.theme.textStrongColor};
  margin-bottom: 10px;

  &::first-letter {
    text-transform: uppercase;
  }
`;

/** Course details' tables: rows split by a hairline, no grid of boxes. */
export const courseDetailsLightTableStyles = css`
  border-collapse: collapse;
  border-spacing: 0;
  width: 100%;

  th {
    padding: 0 8px 6px 0;
    text-align: left;
    font-weight: normal;
    border-bottom: 1px solid ${props => props.theme.borderColor};
  }

  th span {
    display: inline-block;
    color: ${props => props.theme.disabledTextColor};
    &::first-letter {
      text-transform: uppercase;
    }
  }

  td {
    border: 0 !important;
    border-bottom: 1px solid ${props => props.theme.borderColor} !important;
    padding: 8px 8px 6px 0;
    vertical-align: top;
    box-sizing: border-box;
  }

  th:last-child,
  td:last-child {
    vertical-align: middle;
  }

  ${!isTouchScreen
    ? `
      tr:hover {
        td:last-of-type ${HoverDelete} { opacity: 1; }
      }`
    : `td:last-of-type ${HoverDelete} { opacity: 1; }`}
`;

export const courseDetailsTableStyles = css`
  border-collapse: collapse;
  border-spacing: 0;
  width: 100%;

  th {
    padding: 4px 8px;
    text-align: left;
    border-bottom: 1px solid ${props => props.theme.borderColor};
  }

  th span {
    text-transform: uppercase;
    color: ${props => props.theme.textColor};
  }

  td {
    border-width: 1px 1px 1px 0;
    border-color: ${props => props.theme.borderColor};
    border-style: solid;
    padding: 8px 8px 4px;
    vertical-align: top;
    box-sizing: border-box;
  }

  th:last-child,
  td:last-child {
    border: 0;
    vertical-align: middle;
  }

  ${!isTouchScreen
    ? `
      tr:hover {
        td:last-of-type ${HoverDelete} { opacity: 1; }
      }`
    : `td:last-of-type ${HoverDelete} { opacity: 1; }`}
`;
